import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog",
  id: "AddUnit"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  type: "button",
  class: "close",
  ref: "dismissButton",
  "data-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-row mb-3" }
const _hoisted_11 = { class: "col col-3 my-auto" }
const _hoisted_12 = {
  class: "my-1 mr-2",
  for: "lessonName"
}
const _hoisted_13 = { class: "col col-9" }
const _hoisted_14 = { class: "form-row mb-3" }
const _hoisted_15 = { class: "col col-3 my-auto" }
const _hoisted_16 = {
  class: "my-1 mr-2",
  for: "vocabList"
}
const _hoisted_17 = { class: "col col-9" }
const _hoisted_18 = {
  type: "file",
  name: "file",
  placeholder: "Beispielsliste.CSV",
  class: "form-control",
  id: "vocabList",
  accept: ".csv, .CSV",
  ref: "fileInput"
}
const _hoisted_19 = { class: "float-right" }
const _hoisted_20 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _mergeProps({
      class: "btn btn-primary",
      "data-toggle": "modal",
      "data-target": "#AddUnit"
    }, _ctx.$attrs), _toDisplayString(_ctx.$t("messages.Add Lesson")), 17),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("messages.Create Lesson")), 1),
            _createElementVNode("button", _hoisted_6, _hoisted_8, 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.name")), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "lessonName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.lessonName = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.lessonName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("messages.Vocabulary list")), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", _hoisted_18, null, 512)
              ])
            ]),
            _createElementVNode("small", _hoisted_19, _toDisplayString(_ctx.$t("messages.*optional")), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addLesson && _ctx.addLesson(...args)))
            }, _toDisplayString(_ctx.$t("messages.Create Lesson")), 1)
          ])
        ])
      ])
    ])
  ], 64))
}